import "./index.css"

import {
  defineCustomElementTdsPageHeader,
  defineCustomElementTdsPageHeaderNav,
} from "tapestry-wc"

defineCustomElementTdsPageHeader()
defineCustomElementTdsPageHeaderNav()
